import axios from 'axios';
import { constructServiceURL } from '../../../../../utils/URLTools';

export const apiFetchMrdMonitoringReportsNoSync = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getMrdMonitoringReportsAllMRDs',
    stub: process.env.useStubbedEndpoints,
    queryStringParams: {
      filter: 'NoSync',
    },
  });
  return axios.get(serviceURL, payload);
};
